import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
  memo,
} from "react";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import {
  formatMoneda,
  getComparator,
  stableSort,
  EnhancedTableHead,
} from "../../../util/varios";
import "react-tabs/style/react-tabs.css";
import moment from "moment";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import { ActualizarPagosWeb } from "./modalActualizarPagoWeb";
import axios from "axios";
import CatalogoVerificacion from "../../../catalogos/catalogoVerificarPagos";
import { Input, Radio, SearchInput, Select } from "../../../ui/inputs/Input";
import {
  DangerButton,
  InfoButton,
  SuccessButton,
  WarningButton,
} from "../../../ui/buttons/Button";
import ModalPagosRechazados from "./ModalPagosRechazados";
import ModalRechazarVerificacion from "./ModalRecahzarVerificacion";

const getRowKey = (row) => {
  const nrofactura = (row.nrofactura || "").trim();
  const periodo = (row.periodo || "").trim();
  const nrodocumento = (row.nrodocumento || "").trim();
  const monto =
    row.monto === null || row.monto === undefined
      ? ""
      : row.monto.toString().trim();

  return `${nrofactura}${periodo}${nrodocumento}${monto}`;
};

const RowTabla = memo(function RowTabla({
  row,
  rowKey,
  isSelected,
  verificacion,
  desabilitarRows,
  onCheck,
  onPrint,
  onEdit,
  motivoRechazo,
}) {
  const labelId = `enhanced-table-checkbox-${rowKey}`;

  const nrofactura = (row.nrofactura || "").trim();
  const periodo = (row.periodo || "").trim();
  const nrodocumento = (row.nrodocumento || "").trim();
  const cuentabancaria = (row.cuentabancaria || "").trim();
  const contribuyente = row.contribuyente || "";

  const fecha = row.fecha ? moment.utc(row.fecha).format("DD/MM/YYYY") : "";

  const fechaPago = row.fechaoperacion
    ? moment.utc(row.fechaoperacion).format("DD/MM/YYYY")
    : fecha;

  const monto = row.monto
    ? formatMoneda(row.monto.toString().replace(".", ","), ",", ".", 2)
    : "";

  return (
    <tr role="checkbox" aria-checked={isSelected} tabIndex={-1}>
      <td className="letra-tabla-td">
        {verificacion === 0 ? (
          ""
        ) : (
          <Checkbox
            checked={isSelected}
            color="primary"
            inputProps={{
              "aria-labelledby": labelId,
              "data-rowkey": rowKey,
            }}
            onChange={onCheck}
          />
        )}{" "}
      </td>

      <td style={{ textAlign: "center", fontSize: "10px", width: "400px" }}>
        {cuentabancaria}
      </td>
      <td style={{ textAlign: "center", fontSize: "10px", width: "10px" }}>
        {nrodocumento}
      </td>
      <td style={{ textAlign: "center", fontSize: "10px", width: "10px" }}>
        {row.tipo}
      </td>
      <td style={{ textAlign: "center", fontSize: "10px", width: "10px" }}>
        {fecha}
      </td>
      <td style={{ textAlign: "right", fontSize: "10px" }}>{monto}</td>
      <td style={{ textAlign: "center", fontSize: "10px", width: "10px" }}>
        {nrofactura}
      </td>
      <td style={{ textAlign: "center", fontSize: "10px", width: "10px" }}>
        {row.idcontribuyente}
      </td>
      <td style={{ textAlign: "center", fontSize: "10px", width: "150px" }}>
        {contribuyente}
      </td>
      <td style={{ textAlign: "center", fontSize: "10px", width: "10px" }}>
        {periodo}
      </td>
      <td style={{ textAlign: "center", fontSize: "10px", width: "250px" }}>
        {fechaPago}
      </td>
      {verificacion === 2 && (
        <td style={{ textAlign: "center", fontSize: "10px", width: "250px" }}>
          {motivoRechazo || ""}
        </td>
      )}
      <td align="center" style={{ textAlign: "center" }}>
        {row.documen && row.documen.toString() !== "" ? (
          <button
            type="button"
            onClick={onPrint}
            data-doc={row.documen}
            className="btn btn-sm btn-primary rounded-circle mx-2"
          >
            <i className="fas fa-receipt"></i>
          </button>
        ) : (
          ""
        )}

        {verificacion === 0 ? (
          ""
        ) : (
          <button
            type="button"
            disabled={desabilitarRows}
            onClick={onEdit}
            data-rowkey={rowKey}
            className="btn btn-sm btn-warning rounded-circle"
          >
            <i className="fas fa-edit"></i>
          </button>
        )}
      </td>
    </tr>
  );
});

function TablaVerificacion() {
  const token = useMemo(() => localStorage.getItem("jwtToken"), []);
  const op = useMemo(() => require("../../../modulos/datos"), []);
  const espiritu = useMemo(
    () => JSON.parse(localStorage.getItem("espiritu")),
    [],
  );
  const anioActu = useMemo(() => localStorage.getItem("anioactu"), []);

  const [liquidador, setLiquidador] = useState("");
  const [tipoimpu, setTipoimpu] = useState();
  const [showPagosRechazados, setShowPagosRechazados] = useState(false);

  const [fechaSistema] = useState(
    JSON.parse(localStorage.getItem("fechasistema")),
  );

  const [fechaVerifi, setFechaVerifi] = useState("");
  const [idusuario, setIdUsuario] = useState("");
  const [buscarBtn, setBuscarBtn] = useState(true);

  const txtAccion = useRef();
  const txtPrefactura = useRef();

  const [cuentaBancaria, setCuentaBancaria] = useState();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [titulo, setTitulo] = useState();
  const [activo1, setActivo1] = useState(true);
  const [msg, setMsg] = useState();
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [data, setData] = useState();
  const [operacion] = useState(0);
  const [tipoImpuesto, setTipoImpuesto] = useState();
  const [visibleB, setVisibleB] = useState("hidden");
  const [visibleF, setVisibleF] = useState("hidden");
  const [desabilitarRows, setDesabilitarRows] = useState(false);
  const [configCome, setConfigCome] = useState();
  const [verificacion, setVerificacion] = useState("");
  const [contar, setContar] = useState(0);
  const [tipoPago, setTipoPago] = useState();
  const [idVerificacion, setIdVerificacion] = useState();

  const [cedulaR, setCedulaR] = useState(
    JSON.parse(localStorage.getItem("persona")),
  );

  const [disabletbtn, setDisabletbtn] = useState({
    consultar: false,
    verificar: false,
    rechazar: false,
    editar: false,
  });

  const headCells = [
    {
      id: "cuentabancaria",
      label: "CUENTA BANCARIA",
      width: "300px",
      textAlign: "center",
      color: "white",
      disableSorting: false,
    },
    {
      id: "nrodocumento",
      label: "DOCUMENTO",
      width: "100px",
      textAlign: "center",
      color: "white",
      disableSorting: false,
    },
    {
      id: "tipo",
      label: "TIPO",
      width: "80px",
      textAlign: "center",
      color: "white",
      disableSorting: false,
    },
    {
      id: "fecha",
      label: "FECHA",
      width: "60px",
      textAlign: "center",
      color: "white",
      disableSorting: false,
    },
    {
      id: "monto",
      label: "MONTO",
      width: "60px",
      textAlign: "center",
      color: "white",
      disableSorting: false,
    },
    {
      id: "nrofactura",
      label: "FACTURA",
      width: "130px",
      textAlign: "center",
      color: "white",
      disableSorting: false,
    },
    {
      id: "idcontribuyente",
      label: "RITM",
      width: "60px",
      textAlign: "center",
      color: "white",
      disableSorting: false,
    },
    {
      id: "contribuyente",
      label: "CONTRIBUYENTE",
      width: "250px",
      textAlign: "center",
      color: "white",
      disableSorting: false,
    },
    {
      id: "periodo",
      label: "PERIODO",
      width: "50px",
      textAlign: "center",
      color: "white",
      disableSorting: false,
    },
    {
      id: "fechaoperacion",
      label: "FECHA PAGO",
      width: "150px",
      textAlign: "center",
      color: "white",
      disableSorting: false,
    },
    ...(verificacion === 2
      ? [
          {
            id: "Motivo",
            label: "MOTIVO",
            width: "80px",
            textAlign: "center",
            color: "white",
            disableSorting: false,
          },
        ]
      : []),
    {
      id: "ope",
      label: "",
      width: "100px",
      textAlign: "center",
      color: "white",
      disableSorting: false,
    },
  ];
  const txtTotal = useRef(null);
  const txtEdit = useRef();
  const cmbTipoImpuesto = useRef();
  const cmbCuentaBan = useRef();
  const txtFechaDesde = useRef();
  const txtFechaHasta = useRef();
  const radioTodosBancos = useRef();
  const radioSeleccionarBanco = useRef();
  const radioTodosDias = useRef();
  const radioSeleccionarFecha = useRef();

  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => items,
  });

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("fecha");
  const [selected, setSelected] = useState([]);
  const [movSelected, setMovSelected] = useState([]);

  const [showMotivo, setShowMotivo] = useState(false);
  const [motivoTarget, setMotivoTarget] = useState(null);
  const [motivosRechazo, setMotivosRechazo] = useState({});

  const esRechazo = verificacion === 2 || verificacion === "2";

  const selectedSet = useMemo(() => new Set(selected), [selected]);

  const rowByKey = useMemo(() => {
    const map = new Map();
    records.forEach((row) => {
      map.set(getRowKey(row), row);
    });
    return map;
  }, [records]);

  const factuSelected = useMemo(() => {
    const facts = [];

    selected.forEach((key) => {
      const row = rowByKey.get(key);
      if (row) {
        facts.push((row.nrofactura || "").trim());
      }
    });

    return facts;
  }, [selected, rowByKey]);

  const totalSeleccionado = useMemo(() => {
    let total = 0;

    selected.forEach((key) => {
      const row = rowByKey.get(key);
      if (row) {
        total += parseFloat(row.monto) || 0;
      }
    });

    return total;
  }, [selected, rowByKey]);

  const totalFormateado = useMemo(() => {
    return formatMoneda(
      totalSeleccionado.toFixed(2).replace(".", ","),
      ",",
      ".",
      2,
    );
  }, [totalSeleccionado]);

  useEffect(() => {
    if (verificacion === 1 || verificacion === 2 || verificacion === 5) {
      if (txtTotal.current) {
        txtTotal.current.value = totalFormateado;
      }
    }
  }, [totalFormateado, verificacion]);

  const visibleRows = useMemo(() => {
    return stableSort(filterFn.fn(records), getComparator(order, orderBy));
  }, [records, filterFn, order, orderBy]);

  const allKeys = useMemo(() => {
    return Array.from(new Set(visibleRows.map(getRowKey)));
  }, [visibleRows]);

  const recordsFactCount = useMemo(() => {
    const map = new Map();

    records.forEach((row) => {
      const factura = (row.nrofactura || "").trim().toLowerCase();
      map.set(factura, (map.get(factura) || 0) + 1);
    });

    return map;
  }, [records]);

  const selectedFactCount = useMemo(() => {
    const map = new Map();

    factuSelected.forEach((factura) => {
      const lower = (factura || "").trim().toLowerCase();
      const current = map.get(lower) || {
        count: 0,
        original: factura,
      };

      current.count += 1;
      map.set(lower, current);
    });

    return map;
  }, [factuSelected]);

  const getTotalEnPunto = useCallback(() => {
    const value = txtTotal.current?.value || "0,00";
    const parsed = value.replace(/\./g, "").replace(",", ".");
    return parsed !== "" ? parsed : "0.00";
  }, []);

  const limpiarMotivosRechazo = useCallback(() => {
    setShowMotivo(false);
    setMotivoTarget(null);
    setMotivosRechazo({});
  }, []);

  useEffect(() => {
    if (!esRechazo) {
      limpiarMotivosRechazo();
    }
  }, [esRechazo, limpiarMotivosRechazo]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = useCallback(
    (event) => {
      if (verificacion === 4) return;

      if (event.target.checked) {
        if (allKeys.length === 0) return;

        if (!esRechazo) {
          setSelected(allKeys);
          return;
        }

        if (event.target) {
          event.target.checked = false;
        }

        setMotivoTarget({
          keys: allKeys,
          replace: true,
        });

        setShowMotivo(true);
      } else {
        setSelected([]);

        if (esRechazo) {
          setMotivosRechazo({});
        }
      }
    },
    [verificacion, esRechazo, allKeys],
  );

  const handleCheck = useCallback(
    (event) => {
      if (verificacion === 4) return;

      const key = event.target.getAttribute("data-rowkey");
      if (!key) return;

      if (!esRechazo) {
        if (event.target.checked) {
          setSelected((prev) => {
            if (prev.includes(key)) return prev;
            return [...prev, key];
          });
        } else {
          setSelected((prev) => prev.filter((item) => item !== key));
        }

        return;
      }

      if (event.target.checked) {
        if (event.target) {
          event.target.checked = false;
        }

        setMotivoTarget({
          keys: [key],
          replace: false,
        });

        setShowMotivo(true);
      } else {
        setSelected((prev) => prev.filter((item) => item !== key));

        setMotivosRechazo((prev) => {
          const copy = { ...prev };
          delete copy[key];
          return copy;
        });
      }
    },
    [verificacion, esRechazo],
  );

  const cancelarMotivoRechazo = () => {
    setShowMotivo(false);
    setMotivoTarget(null);
  };

  const aceptarMotivoRechazo = (motivo) => {
    if (!esRechazo) return;

    const texto = (motivo || "").trim();

    if (!texto) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe ingresar el motivo del rechazo.",
        icono: "error",
      });
      return;
    }

    if (!motivoTarget || !motivoTarget.keys || motivoTarget.keys.length === 0) {
      setShowMotivo(false);
      setMotivoTarget(null);
      return;
    }

    const motivoUpper = texto.toUpperCase();

    setMotivosRechazo((prev) => {
      const copy = motivoTarget.replace ? {} : { ...prev };

      motivoTarget.keys.forEach((key) => {
        copy[key] = motivoUpper;
      });

      return copy;
    });

    setSelected((prev) => {
      if (motivoTarget.replace) {
        return [...motivoTarget.keys];
      }

      const set = new Set(prev);

      motivoTarget.keys.forEach((key) => {
        set.add(key);
      });

      return Array.from(set);
    });

    setShowMotivo(false);
    setMotivoTarget(null);
  };

  const imprimirCapture = useCallback(
    (event) => {
      event.preventDefault();

      const docu = event.currentTarget.getAttribute("data-doc");
      if (!docu) return;

      window.open(
        op.conexioncapture + "/intra/imagen?img=" + docu.toString(),
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    },
    [op],
  );

  const editarMovimientoByKey = useCallback(
    (event) => {
      event.preventDefault();

      const key = event.currentTarget.getAttribute("data-rowkey");
      if (!key) return;

      const row = rowByKey.get(key);
      if (!row) return;

      setTitulo("Informacion");
      setData(row);
      setTipoPago(row.tipo);
      setMostrar5(true);
    },
    [rowByKey],
  );

  const blanquear2 = () => {
    setSelected([]);
    setMovSelected([]);
    setRecords([]);
    setBuscarBtn(true);
    setTipoImpuesto();
    setVerificacion("");

    setDisabletbtn((prev) => ({
      ...prev,
      consultar: false,
      verificar: false,
      rechazar: false,
      editar: false,
    }));

    setLiquidador("");
    setIdUsuario("");
    setFechaVerifi("");
    setDesabilitarRows(false);
    setActivo1(false);

    limpiarMotivosRechazo();
  };

  const selectPagosVerify = (condic) => {
    setLiquidador(localStorage.getItem("liquidador"));
    setIdUsuario(JSON.parse(localStorage.getItem("idusuario")));
    setFechaVerifi(JSON.parse(localStorage.getItem("fechasistema")));

    let endpoint = `${op.conexion}/api/industria/consultar-pagos-web?condicion=${encodeURIComponent(condic)}`; 

    setRecords([]);
    setSelected([]);
    setMovSelected([]);
    limpiarMotivosRechazo();

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setActivate(false);

        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          } else {
            setRecords([]);
          }

          setSelected([]);
          setMovSelected([]);
          limpiarMotivosRechazo();
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response?.data?.message || "Error en la solicitud");
        setActivate(false);
      });
  };

  const seleccionarPagosAVerificar = (idtiping) => {
    setContar(0);
    setActivate(true);
    let condi = ` estatus = 0 and pw.idtipoingreso = ${idtiping} `;

    if (cmbCuentaBan.current?.value && cmbCuentaBan.current?.value > 0 && !radioTodosBancos.current.checked) {
      condi += ` and cb.idcuentabancaria = ${cmbCuentaBan.current?.value}`;
    } else {
      condi += ` and cb.idcuentabancaria > 0`;
    }
    if (radioSeleccionarFecha.current?.checked) {
      condi += ` and fecha between '${txtFechaDesde.current?.value}' and '${txtFechaHasta.current?.value}'`
    } else {
      condi += ` and fecha notnull `
    }
    selectPagosVerify(condi);
  };

  const selectTipoImpu = (pagosweb) => {
    let endpoint = `${op.conexion}/api/industria/selectalltipoimpuesto?pagosweb=${pagosweb}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setTipoImpuesto(response.data);
            setContar((prev) => prev + 1);

            if (
              response.data.idtipoingreso &&
              (verificacion === 4 || verificacion === 5)
            ) {
              if (cmbTipoImpuesto.current !== undefined) {
                cmbTipoImpuesto.current.value = response.data[0].idtipoingreso;
              }
            } else {
              if (cmbTipoImpuesto.current !== undefined) {
                cmbTipoImpuesto.current.value = response.data[0].idtipoingreso;
              }

              seleccionarPagosAVerificar(response.data[0].idtipoingreso);
            }
          } else {
            setTipoImpuesto([]);
          }
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response?.data?.message || "Error en la solicitud");
        setActivate(false);
      });
  };

  const seleccionarTipoImpuesto = () => {
    setContar(0);
    selectTipoImpu(1);
  };

  const SelectCuentaBanco = () => {
    let endpoint = `${
      op.conexion
    }/api/industria/selectallcuentabancarias?depositoweb=${true}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setActivate(false);

        if (response.status === 200) {
          if (response.data.length > 0) {
            setCuentaBancaria(response.data);
          }
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response?.data?.message || "Error en la solicitud");
        setActivate(false);
      });
  };

  const seleccionarConfiguracion = () => {
    let endpoint = op.conexion + "/api/industria/configuracionindustria";

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setConfigCome(response.data);

          if (response.data.valorutMulta === null) {
            setTitulo("Información");

            if (response.data.factormulta === 2) {
              setMsg(
                "El valor de la unidad tributaria para el año " +
                  anioActu +
                  " no esta definido",
              );
            } else if (response.data.factormulta > 2) {
              let tipo = response.data.factormulta - 3;

              setMsg(
                "El valor del " +
                  (tipo === 0
                    ? "Petro"
                    : tipo === 1
                      ? "Sueldo Minimo"
                      : tipo === 2
                        ? "UCAMP"
                        : "") +
                  " para el año " +
                  anioActu +
                  " en el mes en curso no esta definido",
              );
            }
          }
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response?.data?.message || "Error en la solicitud");
        setActivate(false);
      });
  };

  const imprimirPlanilla = (idveri) => {
    let reporte = "";
    let verificador = liquidador === null ? "" : liquidador.trim();

    let cedula =
      cedulaR === null
        ? ""
        : formatMoneda(cedulaR.toString().replace(".", ","), ",", ".", 0);

    let id = idveri;
    let factura = "V" + idveri.toString().padStart(5, 0);

    if (parseInt(espiritu) === 0) {
      reporte = "PlanillaAcarigua";
    } else if (parseInt(espiritu) === 9) {
      reporte = "PlanillaVerificacionAraure";
    } else if (parseInt(espiritu) === 11) {
      reporte = "PlanillaZamora";
    } else {
      reporte = "Planilla";
    }

    window.open(
      op.reportes +
        "/actividadeconomica?" +
        "reporte=" +
        reporte +
        "&VERIFICADOR=" +
        verificador +
        "&CEDULA=" +
        cedula +
        "&ID=" +
        id +
        "&FACTURA=" +
        factura,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const cancelar = () => {
    setActivo1(true);
    setSelected([]);
    setMovSelected([]);
    setRecords([]);
    setVerificacion("");

    setDisabletbtn((prev) => ({
      ...prev,
      consultar: false,
      verificar: false,
      rechazar: false,
      editar: false,
    }));

    setVisibleB("hidden");
    setVisibleF("hidden");

    if (radioTodosBancos.current) radioTodosBancos.current.checked = true;
    if (radioTodosDias.current) radioTodosDias.current.checked = true;
    if (txtPrefactura.current) txtPrefactura.current.value = "";

    setLiquidador("");
    setIdUsuario("");
    setFechaVerifi("");
    setDesabilitarRows(false);

    if (cmbTipoImpuesto.current) cmbTipoImpuesto.current.value = "";
    if (txtTotal.current) txtTotal.current.value = "";

    limpiarMotivosRechazo();
  };

  const procesarVerificacion = (movi) => {
    let endpoint = `${op.conexion}/api/industria/actualizarverificacion/${verificacion}`;

    setActivate(true);

    const textoTipoImpuesto =
      cmbTipoImpuesto.current && cmbTipoImpuesto.current.selectedIndex >= 0
        ? cmbTipoImpuesto.current[cmbTipoImpuesto.current.selectedIndex]?.text
        : "";

    let body = {
      declaweb: Boolean(
        configCome && configCome.declaweb
          ? configCome.declaweb.toString()
          : false,
      ),
      fechasis: moment.utc(fechaSistema).format("YYYY-MM-DD"),
      movimientos: JSON.stringify(movi),
      tipoimpu: verificacion === 5 ? tipoimpu : textoTipoImpuesto,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (
            (verificacion === 1 || verificacion === 5) &&
            txtTotal.current?.value !== "0,00"
          ) {
            imprimirPlanilla(response.data.idverifi);
          }

          setMensaje({
            mostrar: true,
            titulo: "VERFICACIÓN",
            texto: "Operación Realizada Exitosamente.",
            icono: "exito",
          });

          cancelar();
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || "Error en la solicitud",
          icono: "error",
        });

        setActivate(false);
      });
  };

  const procesarSolicitud = () => {
    setContar(0);

    const totalPunto = getTotalEnPunto();
    let veri = [];

    if (verificacion === 1 || verificacion === 2) {
      selected.forEach((key) => {
        const row = rowByKey.get(key);
        if (!row) return;

        const motivoRechazo =
          verificacion === 2 ? motivosRechazo[key] || "" : "";

        veri.push({
          idverificacion: 0,
          idpagoweb: row.idpagoweb,
          idcuentabancaria: row.idcuentabancaria,
          fecha: row.fecha,
          cuentabancaria: (row.cuentabancaria || "").trim(),
          nrodocumento: (row.nrodocumento || "").trim(),
          tipo: row.tipotransaccion,
          nrofactura: (row.nrofactura || "").trim(),
          monto: row.monto,
          idcontribuyente: row.idcontribuyente,
          contribuyente: row.contribuyente !== null ? row.contribuyente : "-",
          periodo: (row.periodo || "").trim(),
          idverificador: idusuario,
          montototal: totalPunto,
          fechaverificacion: fechaSistema,
          idfactura: row.idfactura,
          idtipoingreso: row.idtipoingreso,
          tabla: (row.tabla || "").trim().toLowerCase(),
          montomulta: row.montomulta !== null ? row.montomulta : "0.00",
          montorecargo: row.montorecargo !== null ? row.montorecargo : "0.00",
          montointereses:
            row.montointereses !== null ? row.montointereses : "0.00",
          montoimpuesto:
            row.montoimpuesto !== null ? row.montoimpuesto : "0.00",
          montodeducible:
            row.montodeducible !== null ? row.montodeducible : "0.00",
          deudas:
            row.idpublicidad === null || row.idpublicidad === undefined
              ? " "
              : "'" + row.idpublicidad + "'",
          fechaoperacion: row.fechaoperacion,
        });
        if (verificacion === 2) {
          veri.push({
            motivorechazo: motivoRechazo,
          });
        }
      });
    } else if (verificacion === 5) {
      movSelected.forEach((key) => {
        if (selectedSet.has(key)) return;

        const row = rowByKey.get(key);
        if (!row) return;

        veri.push({
          idverificacion: row.idverificacion,
          idpagoweb: row.idpagoweb,
          idcuentabancaria: row.idcuentabancaria,
          fecha: row.fecha,
          cuentabancaria: (row.cuentabancaria || "").trim(),
          nrodocumento: (row.nrodocumento || "").trim(),
          tipo: row.tipo,
          nrofactura: (row.nrofactura || "").trim(),
          monto: row.monto,
          idcontribuyente: row.idcontribuyente,
          contribuyente: row.contribuyente !== null ? row.contribuyente : "-",
          periodo: (row.periodo || "").trim(),
          idverificador: row.idverificador,
          montototal: totalPunto,
          fechaverificacion: fechaSistema,
          idfactura: row.idfactura,
          idtipoingreso: row.idtipoingreso,
          tabla: (row.tabla || "").trim().toLowerCase(),
          montomulta: row.montomulta,
          montorecargo: row.montorecargo,
          montointereses: row.montointereses,
          montoimpuesto: row.montoimpuesto,
          montodeducible: row.montodeducible,
          totalfactura: totalPunto,
          deudas: row.deudas,
        });
      });
    }

    procesarVerificacion(veri);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarSolicitud();
  };

  const onChangeValidar = () => {
    if (!(verificacion === 1 || verificacion === 2 || verificacion === 5)) {
      return;
    }

    if ((verificacion === 1 || verificacion === 2) && selected.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Usted no ha desmarcado ningun Item!",
        icono: "error",
      });
      return;
    }

    if (verificacion === 5 && selected.length === movSelected.length) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Usted no ha desmarcado ningun Item!",
        icono: "error",
      });
      return;
    }

    if (esRechazo) {
      const sinMotivo = selected.some(
        (key) => !(motivosRechazo[key] || "").trim(),
      );

      if (sinMotivo) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto:
            "Debe ingresar el motivo del rechazo para todos los movimientos seleccionados.",
          icono: "error",
        });
        return;
      }
    }

    let facturaError = null;

    for (const [lowerFact, info] of selectedFactCount.entries()) {
      const totalFact = recordsFactCount.get(lowerFact) || 0;

      if (info.count !== totalFact) {
        facturaError = info.original;
        break;
      }
    }

    if (facturaError) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto:
          "La Factura " +
          facturaError +
          " Posee mas de una Operacion, debe verificar todas las operaciones de una misma factura para poder procesar esa factura.",
        icono: "error",
      });
      return;
    }

    if (verificacion === 1) {
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "¿Esta Seguro de Procesar estos Movimientos como Verificados ?",
        icono: "confirmacion",
      });
    } else if (verificacion === 2) {
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "¿Esta Seguro de Procesar estos Movimientos como Rechazados ?",
        icono: "confirmacion",
      });
    } else if (verificacion === 5) {
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto:
          "¿Esta Seguro de Eliminar estos Movimientos de la Verificación ??",
        icono: "confirmacion",
      });
    }
  };

  const handleSearch = useCallback((e) => {
    const value = e.target.value;

    setFilterFn({
      fn: (items) => {
        if (value === "") {
          return items;
        }

        const term = value.toLowerCase();

        return items.filter((x) => {
          const fecha = x.fecha ? moment.utc(x.fecha).format("DD/MM/YYYY") : "";

          const fechaPago = x.fechaoperacion
            ? moment.utc(x.fechaoperacion).format("DD/MM/YYYY")
            : "";

          const monto = x.monto
            ? formatMoneda(x.monto.toString().replace(".", ","), ",", ".", 2)
            : "";

          const tipoTexto =
            x.tipo === 1
              ? "DEPOSITO"
              : x.tipo === 2
                ? "TRANSFERENCIA"
                : (x.tipo ?? "").toString();

          return (
            (x.cuentabancaria || "").toLowerCase().includes(term) ||
            (x.nrodocumento || "").toLowerCase().includes(term) ||
            tipoTexto.toLowerCase().includes(term) ||
            fecha.toLowerCase().includes(term) ||
            monto.toLowerCase().includes(term) ||
            (x.nrofactura || "").toLowerCase().includes(term) ||
            (x.idcontribuyente ?? "").toString().includes(value) ||
            (x.periodo || "").toLowerCase().includes(term) ||
            fechaPago.toLowerCase().includes(term) ||
            (x.contribuyente || "").toLowerCase().includes(term)
          );
        });
      },
    });
  }, []);

  const rechazarVerificar = (opcion) => (e) => {
    e.preventDefault();

    if (opcion === 1) {
      if (cmbTipoImpuesto.current) cmbTipoImpuesto.current.value = 0;
      setDesabilitarRows(false);
    } else {
      setDesabilitarRows(true);
    }

    setVerificacion(opcion);

    setDisabletbtn((prev) => ({
      ...prev,
      consultar: true,
      verificar: true,
      rechazar: true,
      editar: true,
    }));

    setActivo1(false);
    limpiarMotivosRechazo();
    seleccionarTipoImpuesto();
  };

  const handlecmbTipoImpuesto = (event) => {
    event.preventDefault();
    seleccionarPagosAVerificar(cmbTipoImpuesto.current?.value);
  };

  const handlecmbCuentaBancaria = (event) => {
    event.preventDefault();
    seleccionarPagosAVerificar(cmbTipoImpuesto.current?.value);
  };

  const handleChangeRadioBanco = () => {
    if (radioTodosBancos.current?.checked) {
      setVisibleB("hidden");
    } else if (radioSeleccionarBanco.current?.checked) {
      setVisibleB("visible");
    }

    seleccionarPagosAVerificar(cmbTipoImpuesto.current?.value);
  };

  const handleChangeRadioFecha = (event) => {
    if (event.target.value === "1") {
      setVisibleF("hidden");

      if (txtFechaHasta.current) txtFechaHasta.current.value = fechaSistema;
      if (txtFechaDesde.current) txtFechaDesde.current.value = fechaSistema;
    } else if (event.target.value === "2") {
      const formatted = moment.utc(fechaSistema).format("YYYY-MM-DD");

      if (txtFechaHasta.current) txtFechaHasta.current.value = formatted;
      if (txtFechaDesde.current) txtFechaDesde.current.value = formatted;

      setVisibleF("visible");
    }

    seleccionarPagosAVerificar(cmbTipoImpuesto.current?.value);
  };

  const handleInputChange = (event) => {
    const desde = txtFechaDesde.current?.value || "";
    const hasta = txtFechaHasta.current?.value || "";

    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.id === "inputFechaDesde") {
        if (desde === "") {
          setTitulo("Error");
          setMsg("Fecha Invalida");
        } else if (desde > hasta && hasta !== "") {
          setTitulo("Error");
          setMsg("La fecha de inicio no puede ser superior a la fecha de fin.");
        } else {
          seleccionarPagosAVerificar(cmbTipoImpuesto.current?.value);
        }
      } else if (event.target.id === "inputFechaHasta") {
        if (hasta === "") {
          setTitulo("Error");
          setMsg("Fecha Invalida");
        } else if (desde > hasta && hasta !== "") {
          setTitulo("Error");
          setMsg("La fecha de fin no puede ser inferior a la fecha de inicio.");
        } else {
          seleccionarPagosAVerificar(cmbTipoImpuesto.current?.value);
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else {
      return false;
    }
  };

  const SelectVerificacion = (idverificacion) => {
    let endpoint = `${op.conexion}/api/industria/selectverificacionbyid?idverificacion=${idverificacion}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setActivate(false);

        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            limpiarMotivosRechazo();

            if (verificacion === 4 || verificacion === 5) {
              const newSelecteds = response.data.map(getRowKey);
              setSelected(newSelecteds);
              setMovSelected(newSelecteds);
            } else {
              setSelected([]);
              setMovSelected([]);
            }

            if (verificacion === 0) {
              let totalMonto = 0;

              response.data.forEach((item) => {
                totalMonto += parseFloat(item.monto) || 0;
              });

              if (txtTotal.current) {
                txtTotal.current.value = formatMoneda(
                  totalMonto.toFixed(2).replace(".", ","),
                  ",",
                  ".",
                  2,
                );
              }
            }
          } else {
            setRecords([]);
            setSelected([]);
            setMovSelected([]);
            limpiarMotivosRechazo();
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response?.data?.message || "Error en la solicitud",
          icono: "error",
        });

        setActivate(false);
      });
  };

  const aceptarInfoCat = (
    idve,
    idveficador,
    montot,
    liq,
    prefac,
    tipoing,
    ced,
    status,
    fecha,
  ) => {
    setMostrarCatalogo(false);

    if (verificacion === 5 && status === "1") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La verificación ya fue Pagada",
        icono: "informacion",
      });
    } else if (verificacion === 4 || verificacion === 5) {
      if (tipoing === 2) {
        setTipoimpu("ACTIVIDADES ECONOMICAS");
      } else if (tipoing === 3) {
        setTipoimpu("INMUEBLES URBANOS");
      } else if (tipoing === 19) {
        setTipoimpu("PROPAGANDA COMERCIAL");
      } else if (tipoing === 7) {
        setTipoimpu("PATENTE DE VEHICULO");
      } else if (tipoing === 74) {
        setTipoimpu("RENTAS DE LICORES");
      } else if (tipoing === 10) {
        setTipoimpu("CERTIFICACION Y SOLVENCIAS");
      } else if (tipoing === 16) {
        setTipoimpu("ASEO URBANO");
      } else if (tipoing === 5) {
        setTipoimpu("OTROS INGRESOS ORDINARIOS");
      }

      SelectVerificacion(idve);
      setIdVerificacion(idve);
      setCedulaR(ced);
      setLiquidador(liq);
      setIdUsuario(idveficador);
      setFechaVerifi(fecha);
    } else {
      SelectVerificacion(idve);
      setIdVerificacion(idve);
      setCedulaR(ced);
      setLiquidador(liq);
      setIdUsuario(idveficador);
      setFechaVerifi(fecha);

      if (txtPrefactura.current) {
        txtPrefactura.current.value = idve;
      }
    }
  };

  const handleBtnImprimir = (event) => {
    event.preventDefault();

    if (!txtPrefactura.current || txtPrefactura.current.value === "") {
      setTitulo("NOTIFCAION");
      setMsg("Debe seleccionar una Verificación.");
    } else {
      imprimirPlanilla(idVerificacion);
    }
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const validarActuPagoW = () => {
    setMostrar5(false);
    seleccionarPagosAVerificar(cmbTipoImpuesto.current?.value);
  };

  const abrirCatalogo = () => {
    if (verificacion === "") {
      setTitulo("NOTIFCAION");
      setMsg("Debe Seleccionar Primero Una Acción.");

      if (txtAccion.current) txtAccion.current.focus();
    } else {
      setMostrarCatalogo(!mostrarCatalogo);
    }
  };

  const editar = (opcion) => (e) => {
    e.preventDefault();

    setActivo1(false);
    setBuscarBtn(false);
    setDesabilitarRows(true);
    setVerificacion(opcion);

    setDisabletbtn((prev) => ({
      ...prev,
      consultar: true,
      verificar: true,
      rechazar: true,
      editar: true,
    }));

    setLiquidador(localStorage.getItem("liquidador"));
    setIdUsuario(JSON.parse(localStorage.getItem("idusuario")));
    setFechaVerifi(JSON.parse(localStorage.getItem("fechasistema")));

    limpiarMotivosRechazo();
  };

  const accion = (ac) => (e) => {
    e.preventDefault();

    setVerificacion(ac);
    setDesabilitarRows(true);
    setBuscarBtn(false);

    setDisabletbtn((prev) => ({
      ...prev,
      consultar: true,
      verificar: true,
      rechazar: true,
      editar: true,
    }));

    limpiarMotivosRechazo();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

    if (verificacion === 5) {
      SelectVerificacion(0);
      blanquear2();

      if (txtPrefactura.current) txtPrefactura.current.value = "";
    } else {
      let ids =
        cmbTipoImpuesto.current && cmbTipoImpuesto.current.value
          ? cmbTipoImpuesto.current.value
          : 0;

      let sql;
      let sql1 = " AND idtipoingreso = " + ids;
      let idss = "p.idcuentabancaria > 0";

      sql = " WHERE true " + sql1;

      selectPagosVerify(idss, sql);
      blanquear2();
    }
  };
  const limpiarMovimientosWeb = () => {
    setRecords([]);
    setSelected([]);
    setMovSelected([]);

    setFilterFn({
      fn: (items) => items,
    });

    if (txtTotal.current) {
      txtTotal.current.value = "0,00";
    }

    limpiarMotivosRechazo();
  };
  useEffect(() => {
    SelectCuentaBanco();
    setDesabilitarRows(false);
  }, []);

  useEffect(() => {
    seleccionarConfiguracion();
  }, []);

  return (
    <div className="col-10 m-0 p-2 mx-auto mt-5 border rounded">
      <div className="col-12 m-0 p-0">
        <div className="col-6 col-sm-5 col-md-4 col-lg-3 m-0 p-0">
          <SearchInput
            label="Código:"
            disabled
            ref={txtPrefactura}
            onClickButton={() => abrirCatalogo()}
            disabledButton={verificacion === 1 ? true : buscarBtn}
          />
        </div>

        <div className="col-12 m-0 p-0 my-2">
          <h3 className="text-center fw-bold">
            {verificacion === 0
              ? "Proceso de Consulta"
              : verificacion === 1
                ? "Proceso de Verificacion"
                : verificacion === 2
                  ? "Proceso de Rechazo"
                  : ""}{" "}
          </h3>
        </div>

        <div className="col-12 m-0 p-0 d-flex flex-wrap gap-2 justify-content-end">
          <InfoButton
            icon="fa-eye"
            ref={txtAccion}
            disabled={disabletbtn.consultar}
            onClick={accion(0)}
          >
            Consultar
          </InfoButton>

          <SuccessButton
            disabled={disabletbtn.verificar}
            onClick={rechazarVerificar(1)}
          >
            Verificar
          </SuccessButton>

          <WarningButton
            icon="fa-edit"
            ref={txtEdit}
            disabled={disabletbtn.editar}
            onClick={editar(5)}
          >
            Editar
          </WarningButton>

          <DangerButton
            disabled={disabletbtn.rechazar}
            onClick={rechazarVerificar(2)}
          >
            Rechazar
          </DangerButton>

          <InfoButton
            icon="fa-archive"
            disabled={disabletbtn.rechazar}
            onClick={() => setShowPagosRechazados(true)}
          >
            Pagos Rechazados
          </InfoButton>
        </div>

        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap align-items-center border-azul rounded">
          <legend className="float-none w-auto m-0">
            Datos del Verificador
          </legend>

          <div className="col-6 col-sm-5 col-md-4 col-lg-3 m-0 mb-2 p-0">
            <Input
              label="Código:"
              disabled
              defaultValue={idusuario ? idusuario.trim() : ""}
            />
          </div>

          <div className="col-12 col-lg-9 m-0 mb-2 p-0 pl-lg-2">
            <Input
              label="Nombre y Apellido:"
              disabled
              defaultValue={liquidador && liquidador !== "" ? liquidador : ""}
            />
          </div>

          <div className="col-6 col-sm-5 col-md-4 col-lg-3 m-0 mb-2 mb-lg-0 p-0">
            <Input
              label="Fecha:"
              type="date"
              disabled
              defaultValue={
                fechaVerifi ? moment.utc(fechaVerifi).format("YYYY-MM-DD") : ""
              }
            />
          </div>

          <div className="col-12 col-lg-9 m-0 p-0 pl-lg-2">
            <Select
              label="Tipo Impuesto:"
              disabled={
                verificacion === 0 || verificacion === "" ? true : false
              }
              ref={cmbTipoImpuesto}
              onChange={handlecmbTipoImpuesto}
            >
              {tipoImpuesto &&
                tipoImpuesto.map((impu) => (
                  <option key={impu.idtipoimpuesto} value={impu.idtipoingreso}>
                    {impu.descripcion.trim()}
                  </option>
                ))}
            </Select>
          </div>
        </fieldset>

        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap align-items-center border-azul rounded">
          <legend className="float-none w-auto m-0">Movimientos Web</legend>

          <div className="col-6 col-md-5 col-lg-4 m-0 p-0">
            <SearchInput
              className="search-input"
              placeholder="Buscar"
              onChange={handleSearch}
            />
          </div>

          <div className="col-12 col-lg-8 m-0 p-0 pl-lg-2 d-flex flex-wrap gap-2">
            <div className="col-auto m-0 p-0">
              <Radio
                label="Todos los Bancos"
                name="radioBanco"
                value="1"
                id="radioSi"
                disabled={
                  verificacion === 4 ||
                  verificacion === 0 ||
                  verificacion === 5 ||
                  verificacion === ""
                    ? true
                    : false
                }
                defaultChecked={true}
                ref={radioTodosBancos}
                onClick={handleChangeRadioBanco}
              />
            </div>

            <div className="col-auto m-0 p-0">
              <Radio
                label="Seleccione Banco"
                name="radioBanco"
                value="2"
                id="radioNo"
                disabled={
                  verificacion === 4 ||
                  verificacion === 0 ||
                  verificacion === 5 ||
                  verificacion === ""
                    ? true
                    : false
                }
                ref={radioSeleccionarBanco}
                onClick={handleChangeRadioBanco}
              />
            </div>

            <div
              className="col-12 col-lg-auto m-0 p-0"
              style={{ visibility: visibleB }}
            >
              <Select ref={cmbCuentaBan} onChange={handlecmbCuentaBancaria}>
                <option key="0" value="0">
                  Seleccione Banco
                </option>

                {cuentaBancaria &&
                  cuentaBancaria.map((cta) => (
                    <option
                      key={cta.idcuentabancaria}
                      value={cta.idcuentabancaria}
                    >
                      {cta.nombre + " " + cta.cuentabancaria}
                    </option>
                  ))}
              </Select>
            </div>
          </div>

          <div className="col-12 m-0 mb-2 p-0 d-flex flex-wrap gap-2">
            <div className="col-auto m-0 p-0">
              <Radio
                label="Todos"
                name="radioFecha"
                value="1"
                id="radioFechaTodos"
                disabled={
                  verificacion === 0 ||
                  verificacion === "" ||
                  verificacion === 5
                    ? true
                    : false
                }
                defaultChecked={true}
                ref={radioTodosDias}
                onClick={handleChangeRadioFecha}
              />
            </div>

            <div className="col-auto m-0 p-0">
              <Radio
                label="Por Fecha"
                value="2"
                name="radioFecha"
                id="radioFechaSeleccionar"
                disabled={
                  verificacion === 0 ||
                  verificacion === "" ||
                  verificacion === 5
                    ? true
                    : false
                }
                ref={radioSeleccionarFecha}
                onClick={handleChangeRadioFecha}
              />
            </div>

            <div
              className="col-auto m-0 p-0 d-flex flex-wrap gap-2"
              style={{ visibility: visibleF }}
            >
              <div className="col m-0 p-0">
                <Input
                  label="Desde:"
                  type="date"
                  max={moment.utc(fechaSistema).format("YYYY-MM-DD")}
                  id="inputFechaDesde"
                  defaultValue={moment.utc(fechaSistema).format("YYYY-MM-DD")}
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                  ref={txtFechaDesde}
                />
              </div>

              <div className="col-12 col-md m-0 p-0">
                <Input
                  label="Hasta:"
                  type="date"
                  max={moment.utc(fechaSistema).format("YYYY-MM-DD")}
                  id="inputFechaHasta"
                  defaultValue={moment.utc(fechaSistema).format("YYYY-MM-DD")}
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                  ref={txtFechaHasta}
                />
              </div>
            </div>
          </div>

          <div className="col-12 m-0 mb-2 p-0">
            <Paper>
              <div
                style={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  width: "100%",
                }}
              >
                <table
                  className="table table-striped table-hover table-sm border-table"
                  aria-labelledby="tableTitle"
                  size="small"
                  aria-label="enhanced table"
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={records.length}
                    headCells={headCells}
                    verificacion={verificacion}
                  />

                  <tbody>
                    {visibleRows.map((row) => {
                      const rowKey = getRowKey(row);

                      return (
                        <RowTabla
                          key={row.idpagoweb || rowKey}
                          row={row}
                          rowKey={rowKey}
                          isSelected={selectedSet.has(rowKey)}
                          motivoRechazo={motivosRechazo[rowKey] || ""}
                          verificacion={verificacion}
                          desabilitarRows={desabilitarRows}
                          onCheck={handleCheck}
                          onPrint={imprimirCapture}
                          onEdit={editarMovimientoByKey}
                        />
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Paper>
          </div>

          <div className="col-6 col-sm-5 col-md-4 col-lg-3 m-0 mb-2 mb-lg-0 p-0">
            <Input
              label="Total:"
              readOnly
              ref={txtTotal}
              defaultValue="0,00"
              id="inputTotal"
            />
          </div>

          <div className="col-12 m-0 p-0 d-flex gap-2 justify-content-end">
            <InfoButton
              icon="fa-print"
              disabled={
                verificacion === "" ||
                verificacion === 1 ||
                verificacion === 2 ||
                verificacion === 5
                  ? true
                  : false
              }
              onClick={handleBtnImprimir}
            >
              Imprimir
            </InfoButton>

            <SuccessButton onClick={onChangeValidar} disabled={activo1}>
              Aceptar
            </SuccessButton>

            <DangerButton
              onClick={cancelar}
              disabled={verificacion === "" ? true : false}
            >
              Cancelar
            </DangerButton>
          </div>
        </fieldset>
      </div>

      <CatalogoVerificacion
        show={mostrarCatalogo}
        onHideCancelaCatActi={abrirCatalogo}
        onHideAceptaCat={aceptarInfoCat}
      />

      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>

      <ActualizarPagosWeb
        show={mostrar5}
        titulo={titulo}
        mensaje={msg}
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuPagoW}
        cuentabancaria={cuentaBancaria}
        data={data}
        deshabilitado={deshabilitado}
        tipopago={tipoPago}
        operacion={operacion}
      />

      <ModalPagosRechazados
        show={showPagosRechazados}
        hide={() => {
          setShowPagosRechazados(false);
          limpiarMovimientosWeb();
        }}
      />

      <ModalRechazarVerificacion
        show={showMotivo && esRechazo}
        onHideModal={cancelarMotivoRechazo}
        onHideAceptar={aceptarMotivoRechazo}
      />
    </div>
  );
}

export default TablaVerificacion;
